var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.975,
    height: 27.234,
    viewBox: "0 0 26.975 27.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(-1158.491 -838.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M1183.536,855.23a6.645,6.645,0,0,0-4.721-1.984h-1.969a.99.99,0,0,0-.637.241l-.374.3a6.07,6.07,0,0,1-7.789,0l-.364-.294a1,1,0,0,0-.649-.248h-1.859a6.691,6.691,0,0,0-6.683,6.683V865.1a1,1,0,0,0,.994.994h24.988a.994.994,0,0,0,.993-.994v-5.129A6.637,6.637,0,0,0,1183.536,855.23Zm-.056,4.735V864.1h-23v-4.138a4.7,4.7,0,0,1,4.663-4.731h1.627l.072.054a8.051,8.051,0,0,0,10.31.007l.082-.061h1.587a4.693,4.693,0,0,1,4.66,4.732Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M1171.941,852.742h.038a6.924,6.924,0,1,0-.038,0Zm-4.919-6.98a4.957,4.957,0,1,1,4.957,4.956A4.962,4.962,0,0,1,1167.022,845.762Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.fe30baacb88fa887b0c97e9f1f4accbd.svg";
export { ForwardRef as ReactComponent };